import type { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";

/**
 * Shared page chrome: skip-link, sticky Navbar, <main>, Footer and the
 * cookie banner. Every prerendered route (home, hub, guides) renders inside
 * this so the header/footer stay identical across the site.
 */
export function Layout({ children }: { children: ReactNode }): JSX.Element {
  return (
    <>
      <a
        href="#top"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-primary focus:px-4 focus:py-2 focus:font-body focus:text-label-md focus:text-on-primary"
      >
        Direkt zum Inhalt springen
      </a>
      <Navbar />
      <main id="top" className="bg-background">
        {children}
      </main>
      <Footer />
      <CookieConsent />
    </>
  );
}
